import { FC } from "react"
import { Spinner } from "./Spinner"
import clsx from "clsx"

interface IProgressIndicatorProps {
    message?: string,
    className?: string,
    messageClassName?: string,
    show?: boolean,
    children?: React.ReactNode
}

export const ProgressIndicator: FC<IProgressIndicatorProps> = ({
    message,
    show = false,
    className,
    messageClassName,
    children
}) => {
    if (show === false) return <></>

    return (
        <div className={clsx("d-flex justify-content-center", className)}>
            <Spinner show={show} messageClass={messageClassName} message={message} />
            {children}
        </div>
    )
}